import Services from '../sections/Services';
import Process from '../sections/Process';
import Clients from '../sections/Clients';
import CTA from '../sections/CTA';

export default function ServicesPage() {
  return (
    <>
      <div className="page-top-spacer" />
      <Services />
      <Process />
      <Clients />
      <CTA />
    </>
  );
}
